import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {FeedApiModel} from '../../api/models/feed.api.model';
import {FilterParameterApiModel} from '../../api/models/filter-parameter.api.model';
import {QueryParamsApiModel} from '../../api/models/query-params-api.model';
import {FeedRestService} from '../../api/services/feed.rest.service';

export interface FeedPageResult {
  records: FeedApiModel[];
  total: number;
  page: number;
}

/**
 * Canonical read-only collection for editorial feed content.
 * A future user-authored feed may extend the source without changing its consumers.
 */
@Injectable({providedIn: 'root'})
export class FeedCollectionDataProviderService {
  constructor(private readonly feedRS: FeedRestService) {}

  public getPage(page: number = 1, limit: number = 20): Observable<FeedPageResult> {
    const queryParams = new QueryParamsApiModel();
    queryParams.page = page;
    queryParams.limit = limit;
    queryParams.filters = [
      new FilterParameterApiModel('discriminator', 'NEWS', 'array'),
      new FilterParameterApiModel('discriminator', 'BLOG_POST', 'array'),
    ];

    return this.feedRS.getCollection(queryParams).pipe(map((result) => ({
      records: result.records,
      total: result.total,
      page,
    })));
  }
}
